import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { CheckIcon, LockIcon, DownloadIcon, RotateCcwIcon } from 'lucide-react';
const CHECKOUT_URL = '[TU_LINK_MERCADOPAGO_BASE]';
export function PricingSection() {
  const {
    ref,
    isInView
  } = useInView();
  const goToCheckout = () => {
    const pixelId = '[TU_PIXEL_ID]';
    const contentName = 'CONTROLA LA ANSIEDAD — Pack Completo Base';
    const contentId = 'ANSIEDAD_BASE_001';
    const value = 19990;
    const w = window as any;
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'InitiateCheckout', {
        content_name: contentName,
        content_ids: [contentId],
        value: value,
        currency: 'ARS'
      });
    }
    const img = new Image(1, 1);
    const params = new URLSearchParams({
      id: pixelId,
      ev: 'InitiateCheckout',
      noscript: '1',
      'cd[content_name]': contentName,
      'cd[value]': String(value),
      'cd[currency]': 'ARS'
    });
    img.src = `https://www.facebook.com/tr?${params.toString()}`;
    setTimeout(() => {
      window.open(CHECKOUT_URL, '_blank');
    }, 300);
  };
  return <section className="py-14 px-4 bg-primary" id="pricing" ref={ref} data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10" data-id="element-113">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-114">
            Elegí tu pack
          </h2>
          <p className="text-accent-teal text-lg sm:text-xl" data-id="element-115">
            Acceso inmediato y los 6 bonus gratis incluidos
          </p>
        </motion.div>

        <div className="bg-white rounded-xl py-3 px-6 flex items-center justify-center gap-3 max-w-xs mx-auto mb-8" data-id="element-116">
          <span className="text-gray-700 text-sm font-semibold whitespace-nowrap" data-id="element-117">
            Pago seguro con
          </span>
          <img src="https://cdn.magicpatterns.com/uploads/mMvN5T9AhW2v7rtXaCYNWs/pasted-image.png" alt="Mercado Pago" className="h-8 w-auto" data-id="element-118" />
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-card border-2 border-accent-gold rounded-2xl p-6 sm:p-8 max-w-lg mx-auto relative shadow-2xl" data-id="element-119">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-accent-gold text-primary px-6 py-1.5 rounded-full font-bold text-sm whitespace-nowrap" data-id="element-120">
            ⭐ MÁS ELEGIDO
          </div>

          <h3 className="text-3xl font-bold text-white mb-2 text-center mt-2" data-id="element-121">
            Pack Completo
          </h3>
          <p className="text-accent-teal text-base text-center mb-6" data-id="element-122">
            6 Volúmenes + 6 Bonus Gratis
          </p>

          <ul className="space-y-3 mb-6" data-id="element-123">
            {['6 Volúmenes PDF (360 páginas)', '6 Bonus PDF (90 páginas)', 'Envío inmediato por email en PDF', 'De por vida — sin vencimiento'].map((item, i) => <li key={i} className="flex items-start" data-id="element-124">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 shrink-0" data-id="element-125" />
                <span className="text-white text-lg" data-id="element-126">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-6" data-id="element-127">
            <span className="text-text-secondary line-through text-xl block mb-1" data-id="element-128">
              $39.990
            </span>
            <span className="text-white font-bold text-5xl sm:text-6xl block mb-2" data-id="element-129">
              $19.990
            </span>
            <span className="text-accent-gold text-sm font-semibold tracking-wider uppercase" data-id="element-130">
              ARS · Pago único
            </span>
          </div>

          <button onClick={goToCheckout} className="w-full bg-accent-gold text-primary font-bold text-xl py-5 px-8 rounded-xl hover:scale-[1.03] transition-transform duration-300 glow-gold flex items-center justify-center" data-id="element-131">
            🚀 COMPRAR AHORA — $19.990 →
          </button>

          <div className="bg-white rounded-xl py-3 px-6 flex items-center justify-center gap-3 mt-6" data-id="element-132">
            <span className="text-gray-700 text-sm font-semibold whitespace-nowrap" data-id="element-133">
              Pago seguro con
            </span>
            <img src="https://cdn.magicpatterns.com/uploads/mMvN5T9AhW2v7rtXaCYNWs/pasted-image.png" alt="Mercado Pago" className="h-8 w-auto" data-id="element-134" />
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mt-4 text-text-secondary text-sm" data-id="element-135">
            <div className="flex items-center" data-id="element-136">
              <LockIcon className="w-4 h-4 text-accent-teal mr-2" data-id="element-137" /> Pago Seguro
              SSL
            </div>
            <div className="flex items-center" data-id="element-138">
              <DownloadIcon className="w-4 h-4 text-accent-teal mr-2" data-id="element-139" /> PDF
              Inmediato
            </div>
            <div className="flex items-center" data-id="element-140">
              <RotateCcwIcon className="w-4 h-4 text-accent-teal mr-2" data-id="element-141" />{' '}
              Garantía 7 días
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}